import { Button, Box, Dialog, DialogTitle, DialogContent, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { memo, useState, useMemo } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import strings from '../../Globalization';
import { LCSCIResultModel } from '../../AppGrid/LCSCILotNumberTable';
import { StsResultModel } from '../../AppGrid/StsResultTabel';
import { useCycleInfo } from '../../contexts/CycleInfo/Context';
import { useGridBase } from '../../components/grid/GridBaseContext';

const LCSCIResultForm = LCSCIResultModel.createFormDialog();
const StsResultForm = StsResultModel.createFormDialog()

const EndoIndicatorResult = memo(({ dataProperty = '', data = {}, refreshGrid=false }) => {
	const [openForm, setOpenForm] = useState(false);
	const { fetchData } = useCycleInfo();
	const { refresh } = useGridBase();

	const result = useMemo(() => data[dataProperty] || '', [data, dataProperty]);

	const imageColor = useMemo(() => {
		return result ? (result.indexOf('times') > -1 ? 'red' : '#1ab394') : null
	}, [result]);

	const isCIResultForm = useMemo(() => {
		return dataProperty === 'LCSCIResultIcon';
	}, [dataProperty]);

	const handleFormOpen = () => {
		setOpenForm(true);
	}

	const handleFormClose = () => {
		setOpenForm(false);
	}

	const handleUpdateForm = () => {
		setOpenForm(false);
		if(refreshGrid) {
			refresh();
		}
		fetchData();
	}

	const formAction = [{
			text: strings.Save,
			type: 'submit',
			color: 'success',
			variant: 'contained'
		},
		{
			text: strings.Cancel,
			type: 'button',
			color: 'warning',
			onClick: handleFormClose,
			variant: 'contained'
		}];

	return <Box>
		{result ?
			result.includes('check') ? (
				<CheckIcon fontSize="large" color="success" sx={{ marginTop: -1.3 }} onClick={handleFormOpen} />
			) : (
				<CloseIcon fontSize="large" color="error" sx={{ marginTop: -1.3 }} onClick={handleFormOpen} />
			)
			: (
				<Button size={'small'}
					disableElevation
					onClick={handleFormOpen}
					variant="contained"
					className="print-hide"
					startIcon={<AddIcon />}>
					{strings.Add}
				</Button>
			)}
		<Dialog
			open={openForm}
			onClose={handleFormClose}
			fullWidth={true}
			maxWidth='md'>
			<DialogTitle>
				<Typography fontSize={'inherit'} fontWeight="inherit" color="inherit">
					{isCIResultForm ? strings.CIResult : strings.STSResult}
				</Typography>
				<DialogContent>
					{isCIResultForm ? (
						<LCSCIResultForm
							activeRecord={{
								record: data,
								id: data?.id
							}}
							containerProps={{ elevation: 0 }}
							disableAlerts
							hideCancel
							hideSubmit
							formActions={formAction}
							onRecordSaved={handleUpdateForm}
						/>
					) : (
						<StsResultForm
							activeRecord={{
								record: data,
								id: data?.id
							}}
							containerProps={{ elevation: 0 }}
							disableAlerts
							hideCancel
							hideSubmit
							formActions={formAction}
							onRecordSaved={handleUpdateForm}
						/>
					)}
				</DialogContent>
			</DialogTitle>
		</Dialog>
	</Box>
})
export default EndoIndicatorResult;